import React from 'react';
import { Link } from 'react-router-dom';
import { QrcodeOutlined } from '@ant-design/icons';
import { Button, Card, Typography } from 'antd';

const { Text } = Typography;

const DevicesAndQRSection = ({ 
  isTeamAdmin, 
  isMobile, 
  teamId, 
  team, 
  clientId, 
  yourself, 
  user 
}) => {
  if (!isTeamAdmin) {
    return null;
  }

  return (
    <>
      <Card
        style={{
          width: '100%',
          borderRadius: '8px',
          border: '1px solid #d9d9d9',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          marginBottom: '24px'
        }}
        bodyStyle={{ padding: '20px' }}
      >
        <div style={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row', 
          alignItems: isMobile ? 'flex-start' : 'center',
          justifyContent: 'space-between',
          gap: '16px'
        }}>
          <div style={{ flex: 1, minWidth: isMobile ? '0' : '200px', width: isMobile ? '100%' : 'auto' }}>
            <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '12px' }}>
              View all active devices in use by your team
            </Text>
            <Text style={{ fontSize: '14px', display: 'block', color: '#595959', flex: 1 }}>
              To get started just order your preferred devices from our online store and get them shipped directly to you.
            </Text>
          </div>
          <div style={{ 
            flexShrink: 0,
            width: isMobile ? '100%' : 'auto'
          }}>
            <Link to={`./${teamId}/tags`} style={{ width: isMobile ? '100%' : 'auto', display: 'block' }}>
              <Button
                type="default"
                size="large"
                icon={<QrcodeOutlined />}
                block={isMobile}
                style={{
                  height: '40px',
                  padding: '0 24px',
                  fontSize: '16px',
                  fontWeight: 500,
                  borderRadius: '6px',
                  backgroundColor: '#f5f5f5',
                  borderColor: '#d9d9d9',
                  color: '#595959',
                  width: isMobile ? '100%' : '100%',
                  minWidth: isMobile ? '0' : '180px'
                }}
              >
                Devices, Stands & QRs
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    </>
  );
};

export default DevicesAndQRSection;

